module.exports = __webpack_public_path__ + "static/img/ivr-video-placeholder.ce3db66.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ivr-video-placeholder.png
// module id = k7jw
// module chunks = 1